(() => {
  const header = document.querySelector('.site-header');
  if (header) {
    const wrapper = header.closest('.shopify-section') || header;
    wrapper.classList.add('buyer-sticky-header');
    const measure = () => document.documentElement.style.setProperty('--buyer-header-height', `${wrapper.getBoundingClientRect().height}px`);
    new ResizeObserver(measure).observe(wrapper);
    measure();
  }
  document.querySelectorAll('.collection-controls').forEach((controls) => {
    const search = controls.querySelector('.collection-search');
    if (!search) return;
    // Phones only. The field is lifted out of .collection-controls so it can
    // stay stuck for the whole product list rather than only while the controls
    // block is on screen, and it is styled to read as the lower half of the
    // sticky header rather than as a second bar floating under it.
    // From 990px up the section places the field in the sort row through a
    // named grid area, and moving it out of that container would empty the cell.
    const ownRow = window.matchMedia('(max-width: 989px)');
    const place = () => {
      if (ownRow.matches) {
        if (search.parentElement === controls) controls.before(search);
        search.classList.add('buyer-sticky-search');
        // The field only takes on the header surface once it is actually stuck.
        // At rest it stays an ordinary field in the page flow, so it never reads
        // as a white strip cutting across the layout.
        if (!search.previousElementSibling || !search.previousElementSibling.dataset.stickySentinel) {
          const sentinel = document.createElement('div');
          sentinel.dataset.stickySentinel = 'true';
          sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none';
          search.before(sentinel);
          const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--buyer-header-height'), 10) || 61;
          new IntersectionObserver(
            (entries) => search.classList.toggle('is-stuck', !entries[0].isIntersecting),
            { rootMargin: '-' + headerH + 'px 0px 0px 0px', threshold: 0 }
          ).observe(sentinel);
        }
      } else {
        if (search.parentElement !== controls) controls.prepend(search);
        search.classList.remove('buyer-sticky-search');
      }
    };
    place();
    ownRow.addEventListener('change', place);
  });

  const root = document.querySelector('[data-stripe-page="complete"]');
  if (!root || root.dataset.claimMode === 'true') return;
  const paid = root.querySelector('[data-stripe-state="paid"]');
  const claim = root.querySelector('[data-claim-order-link]');
  if (!paid || !claim) return;
  let started = false;
  const start = () => {
    if (started || paid.hidden) return;
    started = true;
    const confirmedAt = Date.now();
    paid.classList.add('confirmation-arrived');
    const load = (url) => new Promise((resolve, reject) => {
      const script = document.createElement('script'); script.src=url; script.onload=resolve; script.onerror=reject; document.head.append(script);
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced) load('https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.2/dist/confetti.browser.min.js').then(() => {
      const end=confirmedAt+2000;
      if (Date.now() >= end || paid.hidden) return;
      const layer=document.createElement('div');
      layer.className='celebration-layer';
      layer.setAttribute('aria-hidden','true');
      const canvas=document.createElement('canvas');
      layer.append(canvas);
      document.body.append(layer);
      const burst=window.confetti.create(canvas,{resize:true});
      let cleanupTimer;
      const cleanup=()=>{clearInterval(timer);clearTimeout(cleanupTimer);burst.reset();layer.remove();};
      const timer=setInterval(() => {
        if(paid.hidden) { cleanup(); return; }
        if(Date.now()>=end-500) {
          clearInterval(timer);
          layer.classList.add('is-fading');
          cleanupTimer=setTimeout(cleanup,500);
          return;
        }
        for(const x of [0,1]) burst({particleCount:2,angle:x?120:60,spread:55,origin:{x,y:0.65},disableForReducedMotion:true});
      },80);
      window.addEventListener('pagehide',cleanup,{once:true});
    }).catch(()=>{});
    const css=document.createElement('link');css.rel='stylesheet';css.href='https://cdn.jsdelivr.net/npm/driver.js@1.3.1/dist/driver.css';document.head.append(css);
    load('https://cdn.jsdelivr.net/npm/driver.js@1.3.1/dist/driver.js.iife.js').then(() => setTimeout(() => {
      if(paid.hidden) return;
      const findTrigger=(scope)=>{
        const button=scope.querySelector('button[part="activator"][aria-label="Live chat"]');
        if(button) return button;
        for(const element of scope.querySelectorAll('*')) if(element.shadowRoot){const found=findTrigger(element.shadowRoot);if(found)return found;}
        return null;
      };
      const trigger=findTrigger(document);
      const order=root.querySelector('[data-order-name]')?.textContent?.trim();
      const safeOrder=(order || '').replace(/[<>&"']/g,'');
      const steps=[
        {element:'#order-confirmed-badge',popover:{title:'🎉 Payment Successful!',description:`Your order ${safeOrder} is confirmed and ready to claim.`,side:'bottom',align:'center'}},
        {element:'#claim-order-btn',popover:{title:'💬 Click CHAT WITH US',description:'This opens your claim page with your order details. Live Chat opens there automatically. Confirm your Roblox username with your delivery agent. If chat stays closed, press Open Live Chat on that page.',side:'top',align:'center'}},
        {popover:{title:'⚡Need Help Anytime? Chat is Always Open!',description:'Closed your chat window by mistake? Just click the floating Live Chat icon at the bottom corner of your screen to reconnect with our delivery team whenever you need.',side:'left',align:'center'}}
      ];
      if(trigger && trigger.getBoundingClientRect().width) steps[2].element=trigger;
      if(root.querySelector('#order-confirmed-badge').hidden) delete steps[0].element;
      const tour=window.driver.js.driver({showProgress:true,progressText:'{{current}} of {{total}}',animate:!reduced,allowClose:false,allowKeyboardControl:false,disableActiveInteraction:true,showButtons:['next','previous'],popoverClass:'bloxman-walkthrough',overlayColor:'#0f172a',overlayOpacity:0.75,stageRadius:12,stagePadding:8,doneBtnText:'Got it',nextBtnText:'Next →',prevBtnText:'Back',steps});
      if (root.dataset.optionalTour === 'true') {
        const help = document.createElement('button');
        help.type = 'button';
        help.textContent = 'Show delivery guide';
        help.className = 'delivery-guide-replay';
        help.addEventListener('click', () => tour.drive());
        claim.parentElement.append(help);
      } else {
        tour.drive();
      }
      window.addEventListener('pagehide',()=>tour.destroy(),{once:true});
    },Math.max(0, confirmedAt + 2000 - Date.now()))).catch(()=>{});
  };
  new MutationObserver(start).observe(paid,{attributes:true,attributeFilter:['hidden']});
  start();
})();
